export function addCartTag(obj) {
  window.gtag("event", "add_to_cart", obj);
}
